export default {
  subscriptionCard: {
    applySubReturn: '申请订阅卡返还',
    copyCardNo: '复制订阅卡号',
    copyCardPassword: '复制订阅密码',
    returnCard: '退卡',
    extendValidity: '延长有效期',
    markValid: '标记有效',
    void: '作废',
    cardPassword: '订阅卡密码',
    agentId: '代理商ID',
    agentName: '代理商名称',
    cardType: '订阅卡类型',
    cardNo: '订阅卡卡号',
    cardStatus: '状态',
    used: '已使用',
    voided: '已作废',
    returnCardDialog: '订阅卡退卡',
    confirm: '确认',
    extendValidityConfirm: '确定要延长30天的订阅卡有效期吗？',
    voidConfirm: '确定要将订阅卡标记作废吗？',
    markValidConfirm: '确定要将订阅卡标记有效吗？',
    fissionPayAmount: '订阅卡裂变支付金额',
    fissionReturnAmount: '订阅卡裂变返还金额',
    cashPayAmount: '订阅卡现金支付金额',
    returnType: '返还方式',
    pleaseSelectReturnAccount: '请选择返还账户',
    agentCashAccount: '代理商现金账户',
    cashReturnAmount: '订阅卡现金返还金额',
    returnArrivalDate: '返还到账日期',
    agent: '代理商',
    pleaseSelectAgent: '请选择代理商',
    cardStatusLabel: '订阅卡状态',
    pleaseSelectCardStatus: '请选择订阅卡状态',
    pleaseEnterCardNo: '请输入订阅卡卡号',
    buyTime: '购买日期',
    buyTimeColumn: '购买时间',
    validTime: '有效日期',
    returnApplyStatus: '返还状态申请',
    returnApplyStatusColumn: '返还申请状态',
    pleaseSelectReturnApplyStatus: '请选择返还状态申请',
    cannotApply: '不可申请',
    pendingApply: '待申请',
    applied: '已申请',
    purchaseNo: '采购单号',
    pleaseEnterPurchaseNo: '请输入采购单号',
    exitTextUsed: '以下订阅卡属于同一个采购订单发放，其中有订阅卡已使用，因此不能退卡',
    exitTextRelation: '以下订阅卡属于同一个采购订单发放，一旦退卡，将不可再使用，同时该卡对应订单的支付货款将退回对应账户，请确认是否退卡？',
    exitTextSingle: '以下订阅卡退卡后，将不可再使用，同时该卡对应订单的支付货款将退回对应账户，请确认是否退卡？',
    applySuccess: '申请成功！',
    copyFail: '复制失败！',
    viewFail: '查看失败',
    extendSuccess: '延期成功',
    extendFail: '延期失败',
    voidSuccess: '作废成功',
    voidFail: '作废失败',
    markValidSuccess: '标记有效成功',
    markValidFail: '标记有效失败',
    cancelSuccess: '取消成功',
    cancelFail: '取消失败',
    consumeNo: '使用流水号',
    pleaseEnterConsumeNo: '请输入使用流水号',
    useDate: '使用日期',
    to: '至',
    learningMachineAccount: '学习机账户',
    pleaseEnterLearningMachineAccount: '请输入学习机账户',
    cardAgent: '订阅卡代理商',
    pleaseSelectCardAgent: '请选择订阅卡代理商',
    machineAgent: '学习机代理商',
    pleaseSelectMachineAgent: '请选择学习机代理商',
    cardAgentId: '订阅卡代理商ID',
    cardAgentName: '订阅卡代理商名称',
    machineAgentId: '学习机代理商ID',
    machineAgentName: '学习机代理商名称',
    useTime: '使用时间',
    useOperator: '使用操作人',
    renewRegion: '续订区域',
    renewLevel: '续订档位',
    renewMonthNum: '续订月份数',
    songguoSubscriptionCard: '松果订阅卡',
    subscriptionCard: '订阅卡'
  }
}
